import logo from "@/assets/logo.svg";
import EmailIcon from "@mui/icons-material/Email";
import LocationPinIcon from "@mui/icons-material/LocationPin";
import PhoneIcon from "@mui/icons-material/Phone";
import { AppBar, Box, Container, Divider, Paper, Stack, Toolbar, Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
    children: ReactNode;
};

const PublicScaffold = ({ children }: Props): ReactNode => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div">
                        Wingert Auction Portal
                    </Typography>
                </Toolbar>
            </AppBar>

            <Box component="main" sx={{ py: 2, flexGrow: 1 }}>
                <Container>{children}</Container>
            </Box>

            <Paper sx={{ py: 2 }}>
                <Container sx={{ pt: 2 }}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                        <Box sx={{ maxWidth: 300 }}>
                            <Box
                                component="a"
                                href="https://wingertlandservices.com/"
                                sx={{ display: "block", mb: 2 }}
                            >
                                <Box
                                    component="img"
                                    src={logo}
                                    sx={{
                                        display: "block",
                                        height: 40,
                                    }}
                                />
                            </Box>
                            <Typography variant="body2">
                                Wingert Land Services, Inc. is a full-service agriculture real
                                estate firm specializing in farmland and recreational land sales in
                                Southern Minnesota.
                            </Typography>
                        </Box>
                        <div>
                            <Typography variant="h6" sx={{ mt: 1, mb: 2 }}>
                                Contact Information
                            </Typography>
                            <Stack spacing={1}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <LocationPinIcon fontSize="small" color="primary" />
                                    <Typography variant="body2">
                                        1160 S. Victory Dr, Suite 6<br />
                                        Mankato, MN 56001
                                    </Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <PhoneIcon fontSize="small" color="primary" />
                                    <Typography variant="body2">507.248.5263</Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <EmailIcon fontSize="small" color="primary" />
                                    <Typography variant="body2">
                                        info@wingertlandservices.com
                                    </Typography>
                                </Stack>
                            </Stack>
                        </div>
                    </Stack>

                    <Divider sx={{ mt: 4, mb: 2 }} />
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                        Copyright © 2025 | Wingert Land Services | All Rights Reserved.
                    </Typography>
                </Container>
            </Paper>
        </Box>
    );
};

export default PublicScaffold;
